import instance from "../config";
const postPendienteE = async (id_venta_realizada, producto, cantidadEntrega,id_user,fechaEntrega, horaEntrega) => {
  try {
    const response = await instance.post("/api/pendienteEntrega", {
      id_venta_realizada,
      producto,
      cantidadEntrega,
      id_user,
      fechaEntrega,
      horaEntrega,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const getPendienteE = async () => {
  try {
    const response = await instance.get("/api/pendienteEntrega");
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export{
  postPendienteE,
  getPendienteE
}